<template>
  <v-app>
    <v-navigation-drawer fixed :mini-variant="miniVariant" :clipped="clipped" v-model="drawer" transition="slide-x-transition"
      app>
      <v-toolbar flat class="transparent">
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <router-link to="/dashboard">
                <v-avatar size="50">
                  <img src="../../../static/img/cmg_logo.png" />
                </v-avatar>
              </router-link>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="subheading">
                <router-link to="/" tag="span" style="cursor: pointer; font-weight: bold">
                  CHIP MONG
                  <span class="primary--text">GROUP</span>
                </router-link>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>

      </v-toolbar>

      <v-list>
        <template v-for="item in items">
          <v-subheader v-if="item.header" v-text="item.header" :key="item.title"></v-subheader>
          <v-divider v-else-if="item.divider" :key="item.title"></v-divider>
          <v-list-tile v-else :key="item.title" :to="item.to">
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-list-tile @click="signOut">
          <v-list-tile-action>
            <v-icon>input</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sign out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app :clipped-left="clipped" class="primary" dark transition="slide-y-transition">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-btn icon @click.stop="clipped = !clipped">
        <v-icon>web</v-icon>
      </v-btn>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu offset-y :close-on-content-click="false" :nudge-width="200" v-model="menu">
        <v-btn icon slot="activator">
          <v-avatar size="42px">
            <img :src="imageUrl">
          </v-avatar>
        </v-btn>
        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img :src="imageUrl" alt="">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{activeUser.firstName}} {{activeUser.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{activeUser.email}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="toProfile()">my profile</v-btn>
            <v-btn flat @click="signOut()">sign out</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content transition="slide-y-transition">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer class="pa-3">
      <v-spacer></v-spacer>
      <div>&copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import { httpInstance as axios } from '../../api'

export default {
  name: 'mainPage',
  data () {
    return {
      clipped: false,
      drawer: null,
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: '',
      fav: true,
      menu: false,
      message: false,
      hints: true
    }
  },
  computed: {
    ...mapGetters({
      activeUser: 'getActiveUser',
      items: 'getMenuForDrawer'
    }),

    imageUrl: function () {
      return `${axios.defaults.baseURL}${this.activeUser.normal_photo}`
    }
  },
  methods: {
    ...mapActions(['signOut']),

    toProfile: function () {
      this.menu = false
      this.$router.push({ name: 'profileDetail' })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Main.vue